import * as actionTypes from "Redux/Actions/actionTypes";

const doRecoverPassword = (userdata) => {
  return {
    type: actionTypes.RECOVER_PASSWORD_REQUEST,
    data: userdata,
  };
};
export default doRecoverPassword;
